import { queryOptions, skipToken } from '@tanstack/react-query';

import { ScheduleRuleRole } from 'chaika-enums';

import { ScheduleRuleApi } from '@modules/clinics/api/ScheduleRuleApi';

export const scheduleRuleKeys = {
    all: ['scheduleRules'] as const,
    lists: () => [...scheduleRuleKeys.all, 'list'] as const,
    byOffices: (officeIds: readonly string[]) => [...scheduleRuleKeys.lists(), { officeIds }] as const,
    byClinics: (clinicIds: readonly string[], role?: ScheduleRuleRole) =>
        [...scheduleRuleKeys.lists(), { clinicIds, role }] as const,
    byUsers: (userIds: readonly string[], role?: ScheduleRuleRole) =>
        [...scheduleRuleKeys.lists(), { userIds, role }] as const,
    details: () => [...scheduleRuleKeys.all, 'detail'] as const,
    detail: (id: string) => [...scheduleRuleKeys.details(), id] as const,
};

export const scheduleRuleQueryOptions = {
    byOffices: (officeIds: string[]) => {
        const sortedOfficeIds = [...officeIds].sort();

        return queryOptions({
            staleTime: Infinity,
            queryKey: scheduleRuleKeys.byOffices(sortedOfficeIds),
            queryFn: sortedOfficeIds.length ? () => ScheduleRuleApi.list({ officeId: sortedOfficeIds }) : skipToken,
        });
    },
    byClinics: (clinicIds: string[], role?: ScheduleRuleRole) => {
        const sortedClinicIds = [...clinicIds].sort();

        return queryOptions({
            staleTime: Infinity,
            queryKey: scheduleRuleKeys.byClinics(sortedClinicIds, role),
            queryFn: sortedClinicIds.length
                ? () => ScheduleRuleApi.list({ clinicId: sortedClinicIds, role })
                : skipToken,
        });
    },
    byUsers: (userIds: string[], role?: ScheduleRuleRole) => {
        const sortedUserIds = [...userIds].sort();

        return queryOptions({
            staleTime: Infinity,
            queryKey: scheduleRuleKeys.byUsers(sortedUserIds, role),
            queryFn: sortedUserIds.length ? () => ScheduleRuleApi.list({ userId: sortedUserIds, role }) : skipToken,
        });
    },
    byId: (id: string) =>
        queryOptions({
            staleTime: Infinity,
            queryKey: scheduleRuleKeys.detail(id),
            queryFn: () => ScheduleRuleApi.get(id),
        }),
};
